/**
 *
 * FreshPets Font Weights
 *
 */

const fontWeights = {
    heading: 200,
    body: 400
}

export default fontWeights